import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { AttachIcon } from '../../../../content/svg-component';
import { fileHandlerUrl } from '../../../../utils/consts/server';
import { uuidv4 } from '../../../../utils/utility';
import { Modal, Skeleton, Tooltip } from '../../../common';
import momentjs from 'moment-jalaali';
import './converstation.scss';

const Converstation = (props) => {
  const {
    replies,
    ticketDatas,
    language,
    ticketIndex,
    openMessageCollapseIndex,
    loading,
    intl,
  } = props;

  useEffect(() => {
    if (!loading && replies?.length) scrollDown();
  }, [replies?.length, openMessageCollapseIndex, ticketIndex, loading]);

  const [attachmentFile, setAttachmentFile] = useState('');
  const [isShowAttachment, setIsShowAttachment] = useState(false);

  const untilNow = (input) => {
    let today = new Date();
    let date = new Date(input);
    let differencePerDay = Math.round((today - date) / (1000 * 3600 * 24));
    let differencePerHour = Math.round((today - date) / (1000 * 3600));
    let differencePerMinutes = Math.round((today - date) / (1000 * 60));
    switch (differencePerDay) {
      case 0:
        return differencePerHour > 1 ? (
          <div className="text-end text-nowrap">
            (
            <span className="px-1">
              {differencePerHour} <FormattedMessage id="sendticket.hoursago" />
            </span>
            )
          </div>
        ) : differencePerMinutes ? (
          <div className="text-end text-nowrap">
            (
            <span className="px-1">
              {differencePerMinutes}
              <FormattedMessage id="sendticket.minutesago" />
            </span>
            )
          </div>
        ) : (
          <div className="text-end text-nowrap">
            (
            <span className="px-1">
              <FormattedMessage id="sendticket.justnow" />
            </span>
            )
          </div>
        );

      case 1:
        return (
          <span className="text-end text-nowrap">
            <FormattedMessage id="sendticket.yesterday" />
          </span>
        );

      default:
        return (
          <div className="text-end text-nowrap">
            (
            <span className="px-1">
              {differencePerDay} <FormattedMessage id="sendticket.daysago" />
            </span>
            )
          </div>
        );
    }
  };

  const scrollDown = () => {
    const lastMessageId = replies?.length - 1;
    const messasgeEle = document.getElementById(
      `message-container-${openMessageCollapseIndex}`,
    );
    const hasVerticalScrollbar =
      messasgeEle?.scrollHeight > messasgeEle?.clientHeight;
    // check message if has scroll scroll down else no happend
    if (replies.length && hasVerticalScrollbar) {
      const lastMessageEle = document.getElementById(
        `message-${replies[lastMessageId].uniqeId}`,
      );
      lastMessageEle.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  const organizedMessage = (message) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(message, 'text/html');
    return (
      <div
        className="w-100 text-start"
        dangerouslySetInnerHTML={{ __html: doc.body.innerHTML }}
      ></div>
    );
  };

  return (
    <>
      <Modal
        id="attachmentFile"
        detailClass={'align-self-start text-third-dark'}
        titleClass={'text-primary'}
        title={<FormattedMessage id="ticket.attachment" />}
        modalSize={'modal-xl'}
        isOpen={isShowAttachment}
        onClose={() => {
          setIsShowAttachment(false);
        }}
      >
        <div className="w-100 d-flex px-0 pt-2 justify-content-center align-items-center">
          <img
            src={`${fileHandlerUrl}/file/download/${attachmentFile}`}
            alt="image"
            className="rounded-1 col-sm-7 col-12 license-image"
            height={400}
          />
        </div>
      </Modal>
      {loading ? (
        <>
          <div className="d-flex p-4">
            <Skeleton
              className="m-2"
              variant="circle"
              width="2.8rem"
              height="2.8rem"
            />
            <div className="d-flex flex-column">
              <Skeleton variant="rounded" width="10rem" />
              <Skeleton variant="text" width="3rem" className="mt-3 pr-2" />
            </div>
          </div>
          <div className="d-flex flex-row-reverse p-4">
            <Skeleton
              className="m-2"
              variant="circle"
              width="2.8rem"
              height="2.8rem"
            />
            <div className="d-flex flex-column">
              <Skeleton variant="rounded" width="10rem" />
              <Skeleton variant="text" width="3rem" className="mt-3 pr-2" />
            </div>
          </div>
        </>
      ) : (
        <div
          className="p-0"
          id={`message-container-${ticketIndex}`}
          style={{
            maxHeight: '54vh',
            overflowY: 'scroll',
            overflowX: 'hidden',
          }}
        >
          {replies?.map((reply, index) => {
            return (
              <div
                className="px-4 pt-3"
                key={`reply-${index}`}
                id={`message-${reply.uniqeId}`}
              >
                <div
                  className={`d-flex flex-xl-row flex-md-column flex-sm-row flex-column py-3  ${
                    reply.is_operator && 'flex-row-reverse'
                  } `}
                >
                  <div
                    className={`d-flex flex-row justify-content-start align-items-xl-end align-items-md-center align-items-sm-end align-items-center mb-xl-0 mb-md-3 mb-sm-0 mb-3 ${
                      language.direction === 'rtl' ? 'pl-1 pr-0' : 'pr-1 pl-0'
                    }`}
                  >
                    {reply.is_operator && replies.operator ? (
                      <img
                        className={`avatar rounded-circle p-0 mb-md-0 mb-sm-3 mb-0`}
                        src={
                          reply?.operator.basicInfo.avatar &&
                          require(`../../../../content/images/avatars/${replies.operator.basicInfo.avatar}`)
                        }
                        alt="avatar"
                      />
                    ) : (
                      <img
                        className={`avatar rounded-circle p-0 mb-0`}
                        src={require('../../../../content/images/avatars/23.png')}
                        alt="avatar"
                      />
                    )}
                    <span className="d-xl-none flex-row d-md-flex d-sm-none d-flex px-2 pb-1 font-smaller text-muted text-wrap">
                      {reply?.is_operator
                        ? ticketDatas?.operator
                          ? `${ticketDatas?.operator?.firstName ?? '-'} ${
                              ticketDatas?.operator?.lastName ?? '-'
                            }`
                          : intl.formatMessage({ id: 'ticket.notassigned' })
                        : `${ticketDatas?.user?.firstName ?? '-'} ${
                            ticketDatas?.user?.lastName ?? '-'
                          }`}
                    </span>
                  </div>
                  <div className="flex-column px-0 chatbox-size">
                    <div
                      className={`row justify-content-start px-4 ${
                        reply.is_operator && 'flex-row-reverse'
                      }`}
                    >
                      {
                        <span className="d-xl-flex flex-row d-md-none d-sm-flex d-none px-2 pb-1 font-smaller text-muted">
                          {reply?.is_operator
                            ? `${ticketDatas?.operator?.firstName ?? '-'} ${
                                ticketDatas?.operator?.lastName ?? '--'
                              }`
                            : `${ticketDatas?.user?.firstName ?? '-'} ${
                                ticketDatas?.user?.lastName ?? '--'
                              }`}
                        </span>
                      }
                    </div>
                    <div className={`d-flex position-relative `}>
                      <span
                        id="reply-body"
                        className={`d-flex justify-content-end align-items-center col-xl-12 col-md-auto col-sm-12 col-auto text-light font-small py-3  chatbox border-radius-chatbox-${language.direction} shadow bg-secondary  text-start white-space-preline text-justify text-break position-relative`}
                      >
                        {organizedMessage(reply?.body)}
                        <div
                          className={`w-100 position-absolute text-light font-small font-sm-tiny font-xsmall justify-content-end text-muted text-end pt-1 px-0 ${
                            reply.is_operator && 'flex-row-reverse'
                          }`}
                          style={{ bottom: '-20px' }}
                        >
                          <Tooltip
                            position={'top'}
                            content={
                              language.direction === 'ltr'
                                ? `${new Date(
                                    reply.created_date,
                                  ).toDateString()} ${
                                    new Date(reply.created_date)
                                      .toTimeString()
                                      .split(' ')[0]
                                  }`
                                : `${momentjs(
                                    reply.created_date,
                                    'YYYY-M-D',
                                  ).format('jYYYY-jMM-jDD')}
                      ${
                        new Date(reply.created_date)
                          .toTimeString()
                          .split(' ')[0]
                      }`
                            }
                            direction={language.direction}
                            backgroundColor="warning"
                            textColor="dark"
                          >
                            <div
                              key={reply?.ticket_id}
                              id={uuidv4()}
                              className={`cursor-pointer d-flex pt-1 ${
                                reply.is_operator && 'flex-row-reverse'
                              }`}
                              style={{ width: '90%' }}
                            >
                              {untilNow(reply.created_date)}
                            </div>
                          </Tooltip>
                        </div>
                        {reply?.attachmant?.length > 0 && (
                          <>
                            <div
                              className={`image-attach-${language?.direction} p-2 cursor-pointer d-flex align-items-center justify-content-center border border-2 bg-white rounded-circle shadow position-absolute`}
                              // href={`${fileHandlerUrl}/file/download/${reply.attachmant}`}
                              // target="_blank"
                              onClick={() => {
                                setAttachmentFile(reply?.attachmant);
                                setIsShowAttachment(true);
                              }}
                            >
                              <AttachIcon size={20} color="#00798c" />
                              <span
                                className="w-100 text-center text-dark text-nowrap font-tiny position-absolute"
                                style={{
                                  bottom: '-20px',
                                }}
                              >
                                <FormattedMessage id="profile.viewfile" />
                              </span>
                            </div>
                          </>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(Converstation);
